import { useState, useEffect } from "react"
//import { Document, Page, pdfjs } from "react-pdf"

// // Configure the worker for PDF.js
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`

// function PdfViewer({ pdfUrl }) {
//   const [numPages, setNumPages] = useState(null)

//   const onDocumentLoadSuccess = ({ numPages }) => {
//     setNumPages(numPages)
//   }

//   return (
//     <div className="pdf-viewver-container">
//       <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess}>
//         {Array.from(new Array(numPages), (el, index) => (
//           <div key={`page_${index + 1}`} className="pdf-viewver-document">
//             <Page pageNumber={index + 1} />
//           </div>
//         ))}
//       </Document>
//     </div>
//   )
// }

// export default PdfViewer

const PdfViewer = ({ base64String, loading }) => {
  const [pdfUrl, setPdfUrl] = useState(null)

  useEffect(() => {
    if (base64String) {
      try {
        // Decode Base64 to binary data
        const byteCharacters = atob(base64String)
        const byteNumbers = new Array(byteCharacters.length)
          .fill()
          .map((_, i) => byteCharacters.charCodeAt(i))
        const byteArray = new Uint8Array(byteNumbers)

        // Create a Blob from binary data
        const blob = new Blob([byteArray], { type: "application/pdf" })

        // Generate a URL for the Blob
        const url = URL.createObjectURL(blob)
        setPdfUrl(url)

        return () => URL.revokeObjectURL(url) // Cleanup URL on unmount
      } catch (error) {
        console.error("Error processing PDF:", error)
      }
    }
  }, [base64String])

  return (
    <div style={{ height: "100vh", width: "100%" }}>
      {loading ? (
        <div className="loading-container">
          <div className="loading-pdf-message">Loading ...</div>
        </div>
      ) : base64String ? (
        <iframe src={pdfUrl} width="100%" height="100%" title="PDF Viewer" />
      ) : (
        <p>PDF not available</p>
      )}
    </div>
  )
}

export default PdfViewer
